import type { AxiosError, AxiosRequestConfig } from "axios";

import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import type { BaseQueryResult } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { PaginatedLogsType } from "@store/logs/types";
import { PaginatedMetricsData } from "./types";
import axios from "axios";
import { createApi } from "@reduxjs/toolkit/query/react";

const axiosBaseQuery =
    (): BaseQueryFn<AxiosRequestConfig, unknown, AxiosError> =>
    async ({ url, method, data, params }) => {
        try {
            axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL + "/admin";
            axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
                "token"
            )}`;
            const result = await axios({
                url,
                method,
                data,
                params
            });
            return { data: result.data };
        } catch (axiosError) {
            const error = axiosError as AxiosError;
            return {
                error
            };
        }
    };

const METRICS = "Metrics";

const metricsApi = createApi({
    reducerPath: "metrics",
    tagTypes: [METRICS],
    baseQuery: axiosBaseQuery(),
    endpoints: (build) => ({
        getMetrics: build.query<
            PaginatedMetricsData,
            {
                page?: number;
                profile_id?: string;
                owner_name?: string;
            }
        >({
            query: ({ page = 1, ...body }) => {
                return {
                    url: `/surveys/metrics?page=${page}`,
                    method: "GET",
                    params: body
                };
            },
            transformResponse: (res: BaseQueryResult<any>): any => ({
                data: res.data,
                pagination: {
                    total: res.meta.total,
                    perPage: res.meta.per_page,
                    current: res.meta.current_page
                }
            }),
            providesTags: () => [METRICS]
        })
    })
});

export default metricsApi;

export const { useGetMetricsQuery } = metricsApi;
